// 1921 100 638
export const formatDeviceId = (motherboardId = '') =>
  `${motherboardId.substr(0, 4)} ${motherboardId.substr(
    4,
    3,
  )} ${motherboardId.substring(7)}`
